import { render } from "./AposAreaLayoutEditor.vue?vue&type=template&id=0e13c96e&scoped=true"
import script from "./AposAreaLayoutEditor.vue?vue&type=script&lang=js"
export * from "./AposAreaLayoutEditor.vue?vue&type=script&lang=js"

import "./AposAreaLayoutEditor.vue?vue&type=style&index=0&id=0e13c96e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e13c96e"],['__file',"layout-widget/ui/apos/components/AposAreaLayoutEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e13c96e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e13c96e', __exports__)) {
    api.reload('0e13c96e', __exports__)
  }
  
  module.hot.accept("./AposAreaLayoutEditor.vue?vue&type=template&id=0e13c96e&scoped=true", () => {
    api.rerender('0e13c96e', render)
  })

}


export default __exports__